<div class="page-content-smallMargin page-fill">
  <div class="flex-fill d-flex flex-row">
    @if (bankAmounts) {
      <div class="col-sm-6 flex-fill">
        <dx-data-grid
          #dataGrid
          keyExpr="id"
          class="grid-fill h-100 online-data-grid"
          [dataSource]="bankAmounts"
          [showBorders]="true"
          [columnAutoWidth]="false"
          [focusedRowEnabled]="false"
          [showColumnLines]="true"
          (onToolbarPreparing)="onToolbarPreparing($event)"
          (onSelectionChanged)="onSelectionChanged($event)"
          >
          <dxi-column dataField="id" caption="Id" width="60" cssClass="align-right-pad"></dxi-column>
          <dxi-column dataField="bankTransactionType.name" caption="Type"  width="100"></dxi-column>
          <dxi-column dataField="postDate" caption="Date"  width="100"></dxi-column>
          <dxi-column dataField="description" caption="Description" width="275"></dxi-column>
          <dxi-column dataField="amount" dataType="number" [format]="{ type: 'currency', precision: 2 }" width="100" cssClass="align-right-pad"></dxi-column>
          <dxi-column dataField="contributionList" caption="Links" width="75"></dxi-column>
          <dxi-column dataField="deleted" caption="Deleted"  width="100"></dxi-column>
          <dxo-state-storing [enabled]="true" type="sessionStorage" storageKey="online-bank-list-grid"></dxo-state-storing>
          <dxo-filter-row [visible]="true"></dxo-filter-row>
          <dxo-search-panel [visible]="true"></dxo-search-panel>
          <dxo-selection mode="multiple" showCheckBoxesMode="true"></dxo-selection>
          <dxo-export [enabled]="true"></dxo-export>
          <div *dxTemplate="let data of 'toolbarButtons'"></div>
          <div *dxTemplate="let data of 'toolbarText'">
            @if (batches) {
              <span class="me-3">
                <strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong>
                @if (selectedAmount) {
                  <strong class="ms-4">{{ 'Selected Amount: ' }}{{ selectedAmount | currency }}</strong>
                }
              </span>
            }
          </div>
        </dx-data-grid>
      </div>
    }
    @if (givings) {
      <div class="col-sm-6 flex-fill">
        <dx-data-grid
          #givingGrid
          keyExpr="id"
          class="grid-fill h-100 online-data-grid"
          [dataSource]="givings"
          [showBorders]="true"
          [columnAutoWidth]="false"
          [focusedRowEnabled]="false"
          [showColumnLines]="true"
          (onToolbarPreparing)="onToolbarPreparing($event)"
          (onSelectionChanged)="onSelectionChanged($event)"
          >
          <dxi-column dataField="donationDate" caption="Date" width="100"></dxi-column>
          <dxi-column dataField="donorName" dataType="text" caption="Name" width="155"></dxi-column>
          <dxi-column dataField="donorId" caption="DonorId" width="100"></dxi-column>
          <dxi-column dataField="personId" caption="PersonId" width="100"></dxi-column>
          <dxi-column dataField="batchId" caption="Batch" width="100"></dxi-column>
          <dxi-column
            dataField="grossGift"
            dataType="number"
            [format]="{ type: 'currency', precision: 2 }"
            cssClass="align-right-pad"
          ></dxi-column>
          <dxi-column dataField="bankTransactionId" caption="Link Id" width="75" ></dxi-column>
          <dxi-column width="100"></dxi-column>
          <dxo-state-storing [enabled]="true" type="sessionStorage" storageKey="online-giving-list-grid"></dxo-state-storing>
          <dxo-filter-row [visible]="true"></dxo-filter-row>
          <dxo-search-panel [visible]="true"></dxo-search-panel>
          <dxo-selection mode="multiple" showCheckBoxesMode="true"></dxo-selection>
          <div *dxTemplate="let data of 'toolbarButtons'"></div>
          <div *dxTemplate="let data of 'toolbarText'">
            @if (batches) {
              <span class="me-3">
                <strong>{{ givingGrid.instance.totalCount() + ' items' }}</strong>
                @if (selectedAmount) {
                  <strong class="ms-4">{{ 'Selected Amount: ' }}{{ selectedAmount | currency }}</strong>
                }
              </span>
            }
          </div>
        </dx-data-grid>
      </div>
    }
  </div>
</div>
